const DetailItem = ({ label, labelComponent, value }) => (<div className="flex flex-col gap-0.5">
        <p className="label-s text-neutral-secondary-initial flex items-center gap-1">
            {label}
            {labelComponent}
        </p>
        <p className="title-s text-neutral-primary-initial">{value}</p>
    </div>);
const DetailSection = ({ title, items }) => (<div className="flex flex-col gap-3 pb-6 border-b border-neutral-primary-initial last:border-b-0">
        <h2 className="title-m text-neutral-primary-initial">{title}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-3">
            {items.map((item) => (<DetailItem key={item.label} label={item.label} labelComponent={item.labelComponent} value={item.value}/>))}
        </div>
    </div>);
export default DetailSection;
